import DayjsUtils from '@date-io/dayjs'
import {
	Divider,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	Box, IconButton,
	Container,
	TableRow,
	Radio
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TableContainer from "@material-ui/core/TableContainer"
import Tooltip from '@material-ui/core/Tooltip'
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import * as dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack';
import { useActions, useValues } from 'kea';
import AddIcon from '@material-ui/icons/Add';

import geofencelogic from 'src/store/geofence';
import { rgeofencelogic } from 'src/store/report'
import { minHistoryDate } from 'src/utils/constants';

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const columns = [
	{
		field: 'name',
		headerName: 'Geofence Name',
		align: 'left',
		width: 100,
	},
	{
		field: 'actions',
		headerName: 'Actions',
		align: 'right',
		width: 100,
	}
];

const initialGeofenceDataParam = {
	geofence: '',
	start: dayjs().startOf('day'),
	stop: dayjs().endOf('day')
}

const GeofenceDataDialog = () => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	const { geofences } = useValues(geofencelogic);
	const { fetchAll: geofenceFetchAll } = useActions(geofencelogic);

	const { fetch } = useActions(rgeofencelogic);

	const [geofenceDataParam, setGeofenceDataParam] = useState(initialGeofenceDataParam);
	const [open, setOpen] = React.useState(false);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	useEffect(() => {
		geofences ?? geofenceFetchAll();
	}, []) // eslint-disable-line

	if (geofences === null) {
		return (
			<></>
		)
	}
	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};


	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}
	const emptyRows = rowsPerPage - Math.min(rowsPerPage, geofences.length - page * rowsPerPage);

	const handleAdd = () => {
		if (!geofenceDataParam.geofence) {
			enqueueSnackbar('Please Select a Geofence', { variant: 'error' });
			return
		}
		if (dayjs(geofenceDataParam.start).isAfter(geofenceDataParam.stop)) {
			enqueueSnackbar('Please enter correct dates', { variant: 'error' });
			return
		}
		addDataHandler(geofenceDataParam);
		setGeofenceDataParam(initialGeofenceDataParam);
		handleClose();
	}

	const handleChange = (key, value) => {
		let updatedParams = { ...geofenceDataParam };
		updatedParams[key] = value;
		setGeofenceDataParam(updatedParams);
	}

	const handleHotKey = (period, value, lastdays = true) => {
		let updatedParams = { ...geofenceDataParam };
		if (period === 'month') {
			updatedParams.start = dayjs().subtract(value, 'month').startOf('month');
			updatedParams.stop = dayjs().subtract(value, 'month').endOf('month');
		} else if (period === 'week') {
			updatedParams.start = dayjs().subtract(value, 'week').startOf('week');
			updatedParams.stop = dayjs().subtract(value, 'week').endOf('week');
		} else if (period === 'day') {
			updatedParams.start = dayjs().subtract(value, 'day').startOf('day');
			updatedParams.stop = lastdays ? dayjs().subtract(value, 'day').endOf('day') : dayjs().endOf('day');
		}
		setGeofenceDataParam(updatedParams);
	}

	const addDataHandler = (new_data) => {
		fetch(new_data);
	}

	return (
		<>
			<Tooltip title="Generate Report">
				<IconButton aria-label="add" onClick={handleClickOpen}>
					<AddIcon />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='xl'
			>
				<DialogTitle id="form-dialog-title">Generate Report</DialogTitle>
				<DialogContent>
					{/* <DialogContentText>Add Vehicle</DialogContentText> */}

					<div style={{ height: '100%', width: '100%', background: 'white' }}>
						<TableContainer className={classes.container}>
							<Table stickyHeader aria-label="sticky table" size={'small'}>
								<TableHead>
									<TableRow>
										{columns.map((column) => (
											<TableCell
												key={column.field}
												align={column.align}
												style={{ minWidth: column.width }}
											>
												{column.headerName}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{
										geofences && geofences.length > 0 ?
											geofences
												.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
												.map((row) => {
													return (
														<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
															{columns.map((column) => {
																if (column.field === 'enabled') {
																	return (
																		<TableCell key={column.field} align={column.align}>
																			{
																				row[column.field] ?
																					'Enabled'
																					:
																					'Disabled'
																			}
																		</TableCell>
																	)
																}
																if (column.field === 'actions') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				<Radio
																					color="primary"
																					inputProps={{ 'aria-label': 'secondary checkbox' }}
																					checked={geofenceDataParam.geofence === row._id}
																					onChange={() => handleChange('geofence', row._id)}
																				/>
																			</TableCell>
																		</>
																	)
																}
																if (column.field === 'info') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				{`${row.year} ${row.company} ${row.model} ${row.color}`}
																			</TableCell>
																		</>
																	)
																}
																const value = row[column.field];
																return (
																	<TableCell key={column.field} align={column.align}>
																		{column.format && typeof value === "number"
																			? column.format(value)
																			: value}
																	</TableCell>
																);
															})}
														</TableRow>
													);
												})
											: <TableRow>
												<TableCell style={{ height: 61 * rowsPerPage }} colSpan={5} align={'center'}>
													No Data Added.
												</TableCell>
											</TableRow>
									}
									{
										geofences.length > 0 && emptyRows > 0 && (
											<TableRow style={{ height: 61 * emptyRows }}>
												<TableCell colSpan={6} />
											</TableRow>
										)
									}
								</TableBody>
							</Table>
						</TableContainer>
					</div>
				</DialogContent>
				<DialogActions>
					<Container maxWidth={false}>
						<Box>
							<TablePagination
								rowsPerPageOptions={[10, 15, 20]}
								component="div"
								count={geofences ? geofences.length : 0}
								rowsPerPage={rowsPerPage}
								page={page}
								onChangePage={handleChangePage}
								onChangeRowsPerPage={handleChangeRowsPerPage}
							/>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
									<Button onClick={() => handleHotKey('day', 30, false)} color="primary">
										Last 30 Days
									</Button>
									<Button onClick={() => handleHotKey('month', 1)} color="primary">
										Last Month
									</Button>
									<Button onClick={() => handleHotKey('week', 1)} color="primary">
										Last Week
									</Button>
									<Button onClick={() => handleHotKey('day', 1)} color="primary">
										Last Day
									</Button>
								</div>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
									<div style={{ minWidth: '50px' }} >
										<MuiPickersUtilsProvider utils={DayjsUtils}>
											<DateTimePicker
												autoOk
												ampm={false}
												variant="inline"
												label="Start"
												minDate={minHistoryDate}
												value={geofenceDataParam.start}
												onChange={(value) => handleChange('start', value)}
												disableFuture
											/>
										</MuiPickersUtilsProvider>
									</div>
									<div style={{ minWidth: '50px' }} />
									<MuiPickersUtilsProvider utils={DayjsUtils}>
										<DateTimePicker
											autoOk
											ampm={false}
											variant="inline"
											label="Stop"
											value={geofenceDataParam.stop}
											onChange={(value) => handleChange('stop', value)}
											disableFuture
											minDate={geofenceDataParam.start}
											minDateMessage={'Date should not be before \'Start date\''}
										/>
									</MuiPickersUtilsProvider>
								</div>
							</div>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>

								<Button onClick={handleClose} color="primary">
									Cancel
								</Button>
								<Button onClick={handleAdd} color="primary">
									Generate
								</Button>
							</div>
						</Box>
					</Container>
				</DialogActions>
			</Dialog >
		</ >
	)
}

GeofenceDataDialog.propTypes = {
}

export default GeofenceDataDialog
